class SidebarDrawer extends HTMLElement {
  static get observedAttributes() {
    return ['open'];
  }

  constructor() {
    super();
  }

  open() {
    this.toggleState(true);
  }

  close() {
    this.toggleState(false);
  }

  toggleState(isOpen) {
    this.handleComputeScrollbar(isOpen);
    this.handleToggleBodyOverflow();

    const method = isOpen ? 'add' : 'remove';
    this.classList[method]('!translate-x-0', '!opacity-100', 'open');

    const overlay = this.closest('.drawer-container');
    if (overlay) {
      overlay.classList[method]('open');
    }
  }

  handleComputeScrollbar(status = false) {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    const paddingRightValue = status ? `${scrollbarWidth}px` : '';

    document.body.style.paddingRight = paddingRightValue;
  }

  handleToggleBodyOverflow() {
    document.body.classList.toggle('no-scroll');
  }

  handleEscape = (event) => {
    if (event.key === 'Escape') {
      this.close();
    }
  };

  connectedCallback() {
    if (this.hasAttribute('open')) {
      this.open();
    }

    this.closest('.drawer-container')?.addEventListener('click', (event) => {
      if (event.target === event.currentTarget) {
        this.close();
      }
    });

    document.addEventListener('keyup', this.handleEscape);
  }

  disconnectedCallback() {
    document.removeEventListener('keyup', this.handleEscape);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      if (newValue !== null) {
        this.open();
      } else {
        this.close();
      }
    }
  }
}

customElements.define('sidebar-drawer', SidebarDrawer);
